import API from "@utils/plugins/API";

const CapacityUnitService = {
  all: (params) => {
    return API.get("capacity-units", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("capacity-units", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`capacity-units/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`capacity-units/${id}`);
  },
  destroy: (id) => {
    return API.delete(`capacity-units/${id}`);
  },
};

export default CapacityUnitService;
